// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"344":"89532952","453":"3f5e724b","549":"639eea79"}[chunkId] + ".chunk.js");